import grain from "../../assets/grain.png";

export default function EditorialLoader({
  title = "OWL DREAM",
  subtitle = "dream in the dark",
  label = "Editorial",
  duration = 800,
}: {
  title?: string;
  subtitle?: string;
  label?: string;
  duration?: number;
}) {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-brand-ivory pointer-events-none"
      style={{ animation: `od_loader_fade ${duration}ms ease forwards` }}
      aria-hidden
    >
      {/* GRAIN */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.02] mix-blend-multiply"
        style={{
          backgroundImage: `url(${grain})`,
          backgroundRepeat: "repeat",
          backgroundSize: "320px 320px",
        }}
      />

      <div className="relative z-10 text-center px-8">
        <p className="text-[10px] uppercase tracking-[0.6em] text-brand-brownLight">
          {label}
        </p>

        <h1
          className="mt-6 text-[46px] md:text-[68px] font-serif-lux uppercase text-brand-brown"
          style={{ animation: "od_title_reveal 0.8s ease forwards" }}
        >
          {title}
        </h1>

        <div
          className="mx-auto mt-10 h-px bg-brand-gold/80"
          style={{ animation: "od_line_grow 0.8s ease forwards" }}
        />

        <p className="mt-6 text-[10px] uppercase tracking-[0.55em] text-brand-brown/55">
          {subtitle}
        </p>
      </div>
    </div>
  );
}
